export default __webpack_public_path__ + "static/media/pending_actions-gray.7bd5f552.svg";